/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown>, total: NonNullable<unknown> }} Ui_Onboarding_Pill_ContinueInputs */

const en_ui_onboarding_pill_continue = /** @type {(inputs: Ui_Onboarding_Pill_ContinueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Continue setup · ${i?.step}/${i?.total}`)
};

const de_ui_onboarding_pill_continue = /** @type {(inputs: Ui_Onboarding_Pill_ContinueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Einrichtung fortsetzen · ${i?.step}/${i?.total}`)
};

/**
* | output |
* | --- |
* | "Continue setup · {step}/{total}" |
*
* @param {Ui_Onboarding_Pill_ContinueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_pill_continue = /** @type {((inputs: Ui_Onboarding_Pill_ContinueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Pill_ContinueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_pill_continue(inputs)
	return de_ui_onboarding_pill_continue(inputs)
});